import React from 'react'
import PurpleButton from '../../buttons/PurpleButton'

const Change = () => {
    return (
        <section className='bg-brandGrayBlue30 py-32 px-8 sm:px-[58px] md:px-[68px] lg:px-[90px] xl:px-32'>
            <div className='text-center flex flex-col gap-8 xl:text-start'>
                <p className='headerText2'>Eulerity is that change.</p>
                <div className='flex flex-col gap-16'>
                    <p className='bodyText2'>Our all-in-one platform, powered by AI and advanced marketing automation, is the antidote to the fragmented marketing landscape. It offers a unified approach that ensures agility, efficiency, and strategic growth. From local to global, we empower organizations to take complete control of their marketing infrastructure, accommodating both centralized and decentralized strategies with ease.</p>
                    <div className='w-fit m-auto xl:m-0'>
                        <PurpleButton btnText='Talk to Our Team' btnLink='/contact-us' />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Change